import * as React from 'react';

import styles from './charts.module.css';

type Props = {
    header: {
        dotColor?: string;
        text: string;
    };
    rows: {
        label: string;
        value: string | number;
        isPercentage?: boolean;
        dotColor?: string;
    }[];
};

export const ChartTooltip = (props: Props) => {
    return (
        <div className={styles['tooltip-container']}>
            <div className='flex align-center mb-8 font-bold'>
                {props.header.dotColor ? (
                    <div style={{backgroundColor: props.header.dotColor}} className={styles.dot} />
                ) : undefined}
                <div>{props.header.text}</div>
            </div>
            {props.rows.map((row) => (
                <div key={row.label} className='flex mb-8 align-center'>
                    {row.dotColor ? (
                        <div style={{backgroundColor: row.dotColor}} className={styles.dot} />
                    ) : undefined}
                    <div className='flex justify-sb full-width'>
                        <div className='mr-16'>{`${row.label}:`}</div>
                        <div className='flex'>
                            {row.value}
                            {row.isPercentage ? '%' : undefined}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
